import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export const getMostRelevantCategory = (product: ProductVariantExtended): string | null => {

  const MOST_RELEVANT_BREADCRUMB_DEPTH_INCLUDING_ROOT = 4;
  const mainBreadcrumbs = product._breadcrumbs?.[0] || [];

  if (!mainBreadcrumbs.length) {

    return null;
  
  }
  const mostRelevantCategoryId = mainBreadcrumbs.length >= MOST_RELEVANT_BREADCRUMB_DEPTH_INCLUDING_ROOT
    ? mainBreadcrumbs[MOST_RELEVANT_BREADCRUMB_DEPTH_INCLUDING_ROOT - 1]?.id
    : mainBreadcrumbs[mainBreadcrumbs.length - 1]?.id;

  return mostRelevantCategoryId || null;

};
